/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
  disabled?:boolean;
};

const SvgComponent: FC<IProps> = ({ width = 24, height = 24, disabled = false }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 25 24" fill="none">
    <path d="M5.5 12.0864H19.5M19.5 12.0864L12.5 5.08643M19.5 12.0864L12.5 19.0864" stroke={disabled ? "#908E8D": "#262626"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default SvgComponent;
